<template>
  <section class="flights">
    <div v-loading.fullscreen.lock="isLoading" class="infinite-wrap">
      <flights-filter
        :flights="flights"
        @filter-changed="fetchResponses"
      />
      <div v-if="flights.length">
        <flight
          v-for="(item, index) in flights"
          :key="index"
          :flight="item"
        />
      </div>
      <div v-else class="flights__error">
        <span v-if="networkError">Произошел технический сбой. Попробуйте перезагрузить страницу</span>
        <span v-else>Нет рейсов для отображения</span>
      </div>
    </div>
  </section>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { getNow } from '@/helpers/date'
import { mapGetters } from 'vuex'
import Flight from './components/Flight'
import FlightsFilter from './components/FlightsFilter'

const Responses = RepositoryFactory.get('responses')

export default {
  name: 'FlightsMobile',
  components: {
    Flight,
    FlightsFilter,
  },
  data() {
    return {
      flights: [],
      load_point_ids: [],
      unload_point_ids: [],
      types: [],
      // perPage: 200,
      // page: 1,
      isLoading: false,
      networkError: false,
    }
  },
  computed: {
    ...mapGetters({
      getLibObj: 'libs/getLibObj',
    }),
    freightTypesObj() {
      return this.getLibObj('freightTypes')
    },
  },
  mounted() {
    this.fetchResponses()
  },
  methods: {
    async fetchResponses(filters = null) {
      this.isLoading = true
      const params = filters || `?date_from=${getNow('YYYY-MM-DD')}`
      try {
        let { data } = await Responses.getFlights(params)
        this.flights = data
      } catch (e) {
        this.networkError = true
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.flights
  height: calc(100vh - 7rem)
  margin-top: 6.2rem
  padding: 10.2rem 1.6rem 0
  overflow: scroll
  &__error
    width: 92%
    margin: 12rem auto
    padding: 0 1.6rem
    text-align: center
    font-weight: 700
    font-size: 1.8rem
    line-height: 2.4rem
    color: #181818
</style>
